import React, { Component } from 'react'
import { Row } from 'react-bootstrap';
import config from 'react-global-configuration';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

import { BorderLine, CenterVertical, Icon, LogeButtonSlim } from '../GeneralStyle'
import { CompanyCardWrapper, CompanyIndustry, CompanyName, CompanyImageNew, ProfileLabels, HoverCursor } from './MemberProfileStyle'

import ReactGA from "react-ga";

import globeIcon from '../../images/icons/globe_icon.png'
import locIcon from '../../images/icons/location_icon.png'
import phoneIcon from '../../images/icons/phone_icon.png'

class CompanyCard extends Component {

  trackGa() {
    ReactGA.event({
      category: 'Company',
      action: 'External Click',
      label: 'Open Website - Grid - ' + this.props.companyName
    })
  }

  trackGaOpen() {
    ReactGA.event({
      category: 'Company',
      action: 'Click',
      label: 'Open Profile - Grid - ' + this.props.companyName
    })
  }

  render() {
    return (
      <div>
        <CompanyCardWrapper>
          <HoverCursor onClick={() => {
            this.props.history.push("/partner/" + this.props.shortname)
            this.trackGaOpen()
          }}>
            <Row>
              <CenterVertical><CompanyImageNew width={250} height={125} image={`${config.get('CLOUDINARY_URL')}q_auto/w_500/${this.props.logo}.jpg`} /></CenterVertical>
              <CompanyName><strong>{this.props.companyName}</strong></CompanyName>
              <CompanyIndustry><strong>{this.props.industry}</strong></CompanyIndustry>
              <BorderLine borderColor={"#DAB777"} style={{ width: '75%' }} />
            </Row>
          </HoverCursor>
          <Row style={{display: 'flex', flexDirection: 'column', alignItems: 'center', color: 'black', textAlign: 'center'}}>
            <div style={{ height: 32 }}>
              <a onClick={() => this.trackGa()} target="_blank" href={"http://" + this.props.website}>{this.props.website}</a>
            </div>
            <div style={{ height: 32 }}>
              {this.props.address}
            </div>
            <div style={{ height: 32 }}>
              <a href={'tel:' + this.props.phone}>{this.props.phone}</a>
            </div>
            <LogeButtonSlim
                      style={{ borderRadius: 0, width: 200 }}
                      hoverFontColor={"white"}
                      onClick={() => { this.props.history.push("/partner/" + this.props.shortname) }}>
                      Mehr erfahren &gt;</LogeButtonSlim>
          </Row>
        </CompanyCardWrapper>
      </div>
    )
  }
}

CompanyCard.propTypes = {
  companyName: PropTypes.string,
  shortname: PropTypes.string,
  logo: PropTypes.string,
  website: PropTypes.string,
  address: PropTypes.string,
  phone: PropTypes.string,
  industry: PropTypes.string
}

export default withRouter(CompanyCard);



// WEBPACK FOOTER //
// /src/components/internal/CompanyCard.js